export enum NotificationType {
  missed = 'missed',
  today = 'today',
  all = 'all'
}
